import { schema } from 'normalizr';

export const customers = new schema.Entity('customers', {}, { idAttribute: '_id' });
export const orders = new schema.Entity('orders', {}, { idAttribute: '_id' });
export const employees = new schema.Entity('employees', {}, { idAttribute: '_id' });
export const selectTechnicians = new schema.Entity('selectTechnicians', {}, { idAttribute: '_id' });
